<template>
	<div class="homeBox" v-if="isRouterAlive">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
		<div v-if="flag" style="width: 100vw;overflow-x: hidden;">
			<swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if='homelist.banner_list.length'>
				<swiper-slide v-for="(item,index) in homelist.banner_list" :key="index">
					<img :src="$api.$BASE_URL_img + item.img" alt="" @click="swiperJumpForum(item.forum_id)">
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			<!-- 公告栏 -->
			<div class="advite_gg">
				<div class="laba"><img src="../../assets/img/labapng.png" alt=""></div>
				<div class="notice-card-wrapper">
					<div class="header">
						<div class="title">
							<!-- 系统公告 -->
							<div class="message">
								<div class="inner-container" :style="{width: notice.length * 10 + '%'}">
									<span v-html="notice"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="swiper_vertical">
					<van-notice-bar v-if="showviews" speed='20' delay='2'>
						<span v-for="(txt,index) in homelist.rotation_msg" :key="index">{{txt.content}}</span>
					</van-notice-bar>
				</div> -->
			</div>
			<!-- 云锦金榜 -->
			<div class="yunjin_jbBox">
				<div class="yunjin_jbBox-tit">
					<h4>云锦金榜<img src="../../assets/img/icon8.png" alt=""></h4>
					<router-link to="/yjjb" tag="div">
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</router-link>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(item,index) in homelist.yjjb_list" :key="index" v-if="item.cover_image != null">
							<div @click="jumpbookinfo(item.book_id,item.lock_status)">
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" alt="">
							</div>
							<!-- <p class="bookName">
								<span v-for="(bookName,nameIndex) in item.name" v-if="nameIndex > 4 ? false : true">{{bookName}}</span>
							</p> -->
							<p class="jianjie">
								<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
							</p>
						</swiper-slide>
						<swiper-slide v-if="homelist.yjjb_list.length>2">
							<router-link to="/yjjb" tag="div">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;" />
							</router-link>
						</swiper-slide>

					</swiper>
				</div>
			</div>
			<!-- 首页强推 -->
			<div class="shouyeQt">
				<h4>首页强推</h4>
				<div class="qt_list">
					<p v-for="(item,index) in homelist.syqt_list" @click="jumpbookinfo(item.book_id,item.lock_status)" v-if="item.name != null ? true : false">
						<span v-for="(itm,idx) in item.name" v-if="idx > 9 ? false : true">{{itm}}</span>
					</p>
					<!-- <p v-for="(item,index) in homelist.syqt_list" v-if="index > 6 ? false : true" :key="index" @click="jumpbookinfo(item.book_id)">{{item.name}}</p> -->
				</div>
			</div>
			<!-- 精品 -->
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpwjjpUrl('yqwj')">
						<h4>言情完结精品</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div v-for="(item,index) in homelist.yqwjjp_list" :key="index">
						<div class="jp_bookName" v-if="index == 0 ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<div class="jp_bookImg">
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" alt="">
							</div>
							<div>
								<p><span v-for="(bookNam,boIdx) in item.name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
								<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
								<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
							</div>
						</div>
						<div class="bookNameList" v-if="index != 0 &&  item.name != null ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<p><span v-for="(bookname,bookindex) in item.name" v-if="bookindex > 9 ? false : true">{{bookname}}</span></p>
						</div>
					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpwjjpUrl('cawj')">
						<h4>纯爱完结精品</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div v-for="(item,index) in homelist.cawjjp_list" :key="index">
						<div class="jp_bookName" v-if="index == 0 ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<div class="jp_bookImg">
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" alt="">
							</div>
							<div>
								<p><span v-for="(bookNam,boIdx) in item.name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
								<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
								<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
							</div>
						</div>
						<div class="bookNameList" v-if="index != 0 &&  item.name != null ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<p><span v-for="(bookname,bookindex) in item.name" v-if="bookindex > 9 ? false : true">{{bookname}}</span></p>
						</div>
					</div>
				</div>
			</div>
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpwjjpUrl('yswj')">
						<h4>衍生完结精品</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div v-for="(item,index) in homelist.yswjjp_list" :key="index">
						<div class="jp_bookName" v-if="index == 0 ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<div class="jp_bookImg">
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" alt="">
							</div>
							<div>
								<p><span v-for="(bookNam,boIdx) in item.name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
								<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
								<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
							</div>
						</div>
						<div class="bookNameList" v-if="index != 0 ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<p><span v-for="(bookname,bookindex) in item.name" v-if="bookindex > 9 ? false : true">{{bookname}}</span></p>
						</div>
					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpwjjpUrl('vipzb')">
						<h4>VIP新文总榜</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div v-for="(item,index) in homelist.vxwzb_list" :key="index">
						<div class="jp_bookName" v-if="index == 0 ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<div class="jp_bookImg">
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" alt="">
							</div>
							<div>
								<p><span v-for="(bookNam,boIdx) in item.name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
								<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
								<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >8 ? false : true">{{introduceTxt}}</span></p>
							</div>
						</div>
						<div class="bookNameList" v-if="index != 0 &&  item.name != null ? true : false" @click="jumpbookinfo(item.book_id,item.lock_status)">
							<p><span v-for="(bookname,bookindex) in item.name" v-if="bookindex > 9 ? false : true">{{bookname}}</span></p>
						</div>
					</div>
				</div>
			</div>
			<!-- 黑马榜 -->
			<div class="blockHouse">
				<div class="blockHouse_tit">
					<h4>黑马榜</h4>
					<!-- <p class="updata_yp" @click="hypFn">换一批</p> -->
				</div>
				<div>
					<ul class="swiper_ul">
						<swiper class="swiper" :options="sj_swiperOption">
							<swiper-slide v-for="(item,index) in homelist.dark_horse_list" :key="index">
								<li>
									<div class="img_view">
										<img v-lazy="$api.$BASE_URL_img + item.cover_image" @click="jumpbookinfo(item.book_id,item.lock_status)" />
										<div class="input_check">
											<van-checkbox checked-color="#ff4081" v-model="item.selected" @click="checkValue(item.book_id,item.selected)"></van-checkbox>
										</div>
									</div>
									<p class="jianjie">
										<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
									</p>
								</li>
							</swiper-slide>
							<swiper-slide v-if="homelist.dark_horse_list.length>2">
								<div @click.stop="toSoltDetail(11)">
									<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
									background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;" />
								</div>
							</swiper-slide>
						</swiper>
						<!-- <li v-for="(item,index) in homelist.dark_horse_list" :key="index" v-if="index >=4 && index <= 7 ? false : true">
							<div>
								<img v-lazy="$api.$BASE_URL_img + item.cover_image" @click="jumpbookinfo(item.book_id,item.lock_status)" />
							</div>
							<p class="jianjie">
								<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 5 ? false : true">{{jianjieTxt}}</span>
							</p>
						</li> -->
					</ul>
				</div>
				<div class="shoucang">
					<button @click="one_key_collect">一键收藏</button>
				</div>
			</div>
			<!-- 最近更新 -->
			<div class="updata_box">
				<div>
					<div class="updata_tit">
						<p v-for="(item,index) in txtspan" :key="index">
							<span :class="txtspanindex == index ? 'active' : ''" @click="txtspanitem(index)">{{item}}</span>
							<span class="line" v-show="index == 4 ? false : true">|</span></p>
					</div>
					<!-- <div class="updata_yp"><span>换一批</span></div> -->
				</div>
				<div class="updata_book" v-if="txtspanindex == 0">
					<p v-for="(item,index) in homelist.new_list.list" v-if="index<=15" :key="index" @click="jumpbookinfo(item.book_id,item.lock_status)">
						<span v-for="(bookitem,bookindex) in item.book_name" v-if="bookindex > 9 ? false : true">{{bookitem}}</span>
					</p>
				</div>
				<div class="updata_book" v-if="txtspanindex == 1">
					<p v-for="(item,index) in homelist.new_list.yanqing" v-if="index<=15" :key="index" @click="jumpbookinfo(item.book_id,item.lock_status)">
						<span v-for="(bookitem,bookindex) in item.book_name" v-if="bookindex > 9 ? false : true">{{bookitem}}</span>
					</p>
				</div>
				<div class="updata_book" v-if="txtspanindex == 2">
					<p v-for="(item,index) in homelist.new_list.chunai" v-if="index<=15" :key="index" @click="jumpbookinfo(item.book_id,item.lock_status)">
						<span v-for="(bookitem,bookindex) in item.book_name" v-if="bookindex > 9 ? false : true">{{bookitem}}</span>
					</p>
				</div>
				<div class="updata_book" v-if="txtspanindex == 3">
					<p v-for="(item,index) in homelist.new_list.yansheng" v-if="index<=15" :key="index" @click="jumpbookinfo(item.book_id,item.lock_status)">
						<span v-for="(bookitem,bookindex) in item.book_name" v-if="bookindex > 9 ? false : true">{{bookitem}}</span>
					</p>
				</div>
				<div class="updata_book" v-if="txtspanindex == 4">
					<p v-for="(item,index) in homelist.new_list.wucp" v-if="index<=15" :key="index" @click="jumpbookinfo(item.book_id,item.lock_status)">
						<span v-for="(bookitem,bookindex) in item.book_name" v-if="bookindex > 9 ? false : true">{{bookitem}}</span>
					</p>
				</div>
			</div>
			<!-- 热门标签 -->
			<div class="biaoqianBox">
				<div class="biaoqianTitle">
					<h4>热门标签</h4>
					<img src="../../assets/img/arr.png" alt="" @click="more_labelFn">
				</div>
				<div class="biaoqianList" v-if="get_hot_lable_listShow == true ? false : true">
					<button v-for="(item,index) in homelist.label" :key="index" @click="keywordsFn(item.name,item.id)">{{item.name}}</button>
				</div>
				<div class="biaoqianList" v-show="get_hot_lable_listShow == true">
					<button v-for="(item,index) in hot_lable_list" :key="index" @click="keywordsFn(item.name,item.id)">{{item.name}}</button>
				</div>
			</div>
			<div class="lookInfo" @click="go_yanqing()">
				<span>已经到底了，查看看分频道发现更多好文吧~ <br /></span>
			</div>
		</div>
		</van-pull-refresh>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		// props: {
		// 	homeListData: {
		// 		type: Object,
		// 	}
		// },
		// provide() { // 注册一个方法
		// 	return {
		// 		reload: this.reload
		// 	}
		// },
		data() {
			return {
				sj_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				flag: false,
				isRouterAlive: true,
				homelist: {
					rotation_msg: [], //新闻轮播
					banner_list: [], //banner轮播
					yjjb_list: [], //云锦金榜
					syqt_list: [], //首页强推
					yqwjjp_list: [], //言情完结精品
					yswjjp_list: [], //衍生完结精品
					vxwzb_list: [], //VIP完结精品
					new_list: [], //最近更新
					label: [], //热门导航
					dark_horse_list: [], //黑马榜
					cawjjp_list: [], //纯爱完结精品
				},
				getSecondtab: '',
				txtspanindex: 0,
				txtspan: ["最近更新", "言情", "纯爱", "衍生", "无cp"],
				tabbars: [{
						name: "searchPage",
						title: "搜索",
						normal: require("../../assets/tabbar/search.png"),
						active: require("../../assets/tabbar/search.png")
					},
					{
						name: "bookshelf",
						title: "书架",
						normal: require("../../assets/tabbar/bookshelf.png"),
						active: require("../../assets/tabbar/bookshelf.png")
					},
					{
						name: "bookcity",
						title: "书城",
						normal: require("../../assets/tabbar/bookcity.png"),
						active: require("../../assets/tabbar/bookcity.png")
					},
					{
						name: "forum",
						title: "论坛",
						normal: require("../../assets/tabbar/forum.png"),
						active: require("../../assets/tabbar/forum.png")
					},
					{
						name: "mine",
						title: "",
						normal: require("../../assets/tabbar/userimg.png"),
						active: require("../../assets/tabbar/userimg.png")
					}
				],
				//轮播图配置
				swiperOption: {
					spaceBetween: 30,
					centeredSlides: true,
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					autoplay: {
						delay: 1500,
						disableOnInteraction: false
					},
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					}
				},
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				newIdarr_new: [],
				showviews: false,
				get_hot_lable_listShow: false,
				hot_lable_list: [],
				notice: '',
				isLoading: false,
			}
		},
		methods: {
			//  reload() {
			//       this.isRouterAlive = false
			//       this.$nextTick(function() {
			//         this.isRouterAlive = true
			//         console.log('reload')
			//       })
			// },
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.bookcityIndexDataFn();
					this.isLoading = false;
				}, 1000);
			},
			swiperJumpForum(forumId) {
				if (forumId != '') {
					this.$router.push({
						path: '/tieziInfo',
						query: {
							tzxqInfoId: forumId
						}
					})
				} else {
					Toast('暂无对应数据')
				}

			},
			more_labelFn() {
				this.get_hot_lable_listShow = !this.get_hot_lable_listShow;
			},
			// 热门标签
			get_hot_lable_list() {
				this.$axios.post(this.$api.hot_lable_list).then(res => {
					if (res.status == 200) {
						console.log(res, '热门标签')
						this.hot_lable_list = res.data.data
					}
				})
			},
			checkValue(book_id, selected) {
				var _t = this;
				var list = _t.homelist.dark_horse_list;
				var newIdarr = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].selected) {
						newIdarr.push(list[i].book_id)
					}
				}
				_t.newIdarr_new = newIdarr;

			},
			//跳转排行子页面
			toSoltDetail(i) {
				this.$router.push({
					path: '/soltPhDetail',
					query: {
						index: i,
					}
				})
			},
			// 一键收藏
			one_key_collect() {
				var _t = this;
				if (!_t.newIdarr_new.length) {
					_t.$toast('请选择需要收藏的书本');
				} else {
					_t.$axios.post(_t.$api.xianmian_collect, {
						books_ids: JSON.stringify(_t.newIdarr_new)
					}).then(res => {
						if (res.data.code == 1) {
							//清空数组
							_t.newIdarr_new = [];
							//清除选中效果
							var list = _t.homelist.dark_horse_list;
							for (var i = 0; i < list.length; i++) {
								list[i].selected = false;
							}
							_t.homelist.dark_horse_list = list;
						}
						_t.$toast(res.data.msg);
					})
				}

			},
			// 黑马榜换一批 接口数据
			hypFn() {
				// this.$axios.post(this.$api.refresh_darkhorse).then(res => {
				// 	this.homelist.dark_horse_list = res.data.data;
				// })

			},
			//最近更新
			txtspanitem(data) {
				this.txtspanindex = data
			},
			// 首页强推跳详情
			jumpbookinfo(bookid, lock_status) {
				if (lock_status == 0) {
					Toast('该书本已锁定，暂时无法查看')
					return false;
				} else {
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: bookid,
							cityPage: 'cityPageUrl'
						}
					})
				}
			},
			jumpwjjpUrl(a) {
				if (a == 'yqwj') {
					this.$router.push({
						path: '/wanjiejingpingengduo',
						query: {
							cityPage: 'cityPageUrl',
							active: 0,
						}
					})
				} else if (a == 'cawj') {
					this.$router.push({
						path: '/wanjiejingpingengduo',
						query: {
							cityPage: 'cityPageUrl',
							active: 1,
						}
					})
				} else if (a == 'yswj') {
					this.$router.push({
						path: '/wanjiejingpingengduo',
						query: {
							cityPage: 'cityPageUrl',
							active: 2,
						}
					})
				} else if (a == 'vipzb') {
					this.$router.push({
						path: '/wanjiejingpingengduo',
						query: {
							cityPage: 'cityPageUrl',
							active: 3,
						}
					})
				}
			},
			keywordsFn(word, id) {
				console.log(word);
				this.$router.push({
					path: '/searchResult',
					query: {
						keywordHost: word,
						url: 'cityPageUrl',
						labelId: id
					}
				})
			},
			bookcityIndexDataFn() {
				this.$axios.post(this.$api.bookcityIndex).then((response) => {
					if (response.data.code == 1) {
						this.bookcityBox_show = true;
						// 公告栏
						this.homelist.rotation_msg = response.data.data.rotation_msg;
						//banner轮播
						this.homelist.banner_list = response.data.data.banner_list;
						//云锦金榜
						this.homelist.yjjb_list = response.data.data.yjjb_list;
						//首页强推
						this.homelist.syqt_list = response.data.data.syqt_list;
						//言情完结精品
						this.homelist.yqwjjp_list = response.data.data.yqwjjp_list;
						//衍生完结精品
						this.homelist.yswjjp_list = response.data.data.yswjjp_list;
						//VIP完结精品
						this.homelist.vxwzb_list = response.data.data.vxwzb_list;
						//最近更新
						this.homelist.new_list = response.data.data.new_list;
						//热门导航
						this.homelist.label = response.data.data.label;
						//黑马榜
						this.homelist.dark_horse_list = response.data.data.dark_horse_list;
						//纯爱完结精品
						this.homelist.cawjjp_list = response.data.data.cawjjp_list;
						var rotation_msg = '';
						for (var i = 0; i < this.homelist.rotation_msg.length; i++) {
							rotation_msg += this.homelist.rotation_msg[i].content
						}
						this.notice = rotation_msg;
						//数据加载完后，显示公告滚动
						this.showviews = true

					} else {
						Toast(response.data.msg);
					}
				})
			},
			go_yanqing() {
				this.$router.push({
					path: '/yanqing',
					query: {
						categoryIdx: 'yq0'
					}
				})
			}

		},
		created() {
			// console.log('homeListData', this.homeListData);
			// this.homelist = this.homeListData
			// Toast.loading({
			// 	message: '加载中...',
			// 	forbidClick: true,
			// });
			this.bookcityIndexDataFn();
			this.get_hot_lable_list();
		},
		mounted() {
			if (this.homelist != '') {
				this.flag = !this.flag
			}
		},
	}
</script>

<style>
	.reset .van-tabs__line {
		background-color: #ffffff;
	}

	.reset .van-tab--active {
		font-size: 32px;
		/*px*/
		color: #ff4081;
		font-weight: 700;
	}

	.swiper-pagination-bullet {
		background-color: #ff4081;
	}
</style>
<style scoped="scoped" lang="less">
	.swiper-container .swiper-slide img {
		vertical-align: middle !important;
	}

	//轮播图 样式
	.swiper-container {
		.swiper-slide {
			height: 360px;

			img {
				width: 100%;
				display: block;
			}
		}
	}

	.homeBox {
		background-color: #f0f0f0;
		overflow-y: scroll;
		height: calc(100vh - 160px);

		// 公告css
		.advite_gg {
			display: flex;
			padding: 10px 16px;
			height: 68px;
			line-height: 68px;
			background-color: #fff;
			overflow: hidden;
			position: relative;

			.laba {
				img {
					width: 70px;
					position: absolute;
					top: 50%;
					left: 0px;
					transform: translateY(-50%);
					// height: 66px;
				}
			}

			.swiper_vertical {
				width: calc(100vw - 112px);
				position: absolute;
				top: 50%;
				left: 65px;
				transform: translateY(-50%);
				height: 50px;
				line-height: 50px;
				font-size: 28px;
				/*px*/
				color: #686f70;
				overflow: hidden;
				padding-left: 20px;
				border-radius: 50px;
				background-color: rgba(129, 197, 247, .2);

				.van-swipe .van-swipe__track--vertical .van-swipe-item {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.van-notice-bar {
					background: rgba(0, 0, 0, 0);
					color: #686f70;
					height: 55px;
					padding: 0;

					span {
						margin-right: 70px;
					}
				}
			}

			.notice-card-wrapper {
				width: calc(100vw - 112px);
				position: absolute;
				top: 50%;
				left: 65px;
				transform: translateY(-50%);
				height: 50px;
				line-height: 50px;
				font-size: 28px;
				/*px*/
				color: #686f70;
				overflow: hidden;
				padding-left: 20px;
				border-radius: 50px;
				background-color: rgba(129, 197, 247, .2);

				.inner-container {
					margin-left: 50%;
					// width: 10000%;
					animation: myMove 60s linear infinite;
					animation-fill-mode: forwards;
				}
				@keyframes myMove {
					0% {
						transform: translateX(0);
					}

					100% {
						transform: translateX(-8800px);
					}
				}
			}
		}

		// 云锦金榜
		.yunjin_jbBox {
			height: 360px;
			background-color: #fff;
			margin-top: 10px;
			padding: 20px 16px;

			.yunjin_jbBox-tit {
				// padding-top: 10px;
				position: relative;

				h4 {
					display: inline-block;
					color: #ff4081;
					font-size: 30px;
					/*px*/
					height: 50px;
					line-height: 50px;
					font-weight: 700;
					position: relative;

					img {
						width: 40px;
						position: absolute;
						top: -15px;
						right: -26px;
					}
				}

				div {
					img {
						position: absolute;
						right: 0;
						top: 50%;
						width: 50px;
						transform: translateY(-50%);
					}
				}

			}

			.yunjin_jb {
				margin-top: 10px;
				height: 340px !important;

				.swiper-container {
					.swiper-slide {
						width: 28% !important;
						margin-right: 15px !important;

						div {
							text-align: center;

							img {
								width: 190px;
								height: 270px;
								vertical-align: middle;
								-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
							}
						}

						.bookName,
						.jianjie {
							font-size: 30px;
							/*px*/
							overflow: hidden;
							white-space: nowrap;
							padding-top: 10px;
							color: #000;
							margin: 0 auto;
							text-align: center;
						}

						.jianjie {
							font-size: 24px;
							/*px*/
							overflow: hidden;
							white-space: nowrap;
							// text-overflow: ellipsis;
							color: #000;
							opacity: 0.6;
						}
					}
				}
			}
		}

		//首页强推
		.shouyeQt {
			background-color: #fff;
			margin-top: 10px;
			padding: 0 16px;

			h4 {
				color: #ff4081;
				font-size: 30px;
				/*px*/
				height: 74px;
				line-height: 74px;
			}

			.qt_list {
				overflow: hidden;

				p {
					width: calc(50% - 20px);
					// padding-left: 20px;
					float: left;
					line-height: 60px;
					font-size: 30px;
					/*px*/
					color: #000;
					height: 60px;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}

		}

		//精品
		.jinpinBox {
			margin-top: 10px;
			overflow: hidden;
			background-color: #fff;

			.jinpin_left {
				width: calc(50% - 31px);
				margin-bottom: 10px;
				background-color: #fff;
				float: left;
				padding-left: 16px;
				padding-right: 25px;
				padding-bottom: 16px;
				overflow: hidden;

				.jp_title {
					display: flex;
					height: 78px;
					line-height: 78px;
					position: relative;

					h4 {
						flex: 1;
						font-size: 30px;
						/*px*/
						color: #ff4081;
					}

					div {
						padding-right: 10px;

						img {
							width: 50px;
							position: absolute;
							top: 50%;
							right: 0;
							transform: translateY(-50%);
						}
					}
				}

				.jp_bookName {
					display: flex;
					height: 240px;
					position: relative;

					.jp_bookImg {
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						width: 155px;
						height: 220px;
						/*px*/
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);

						/*no*/
						img {
							width: 155px;
							height: 220px;
							/*px*/
							display: block;
						}
					}

					div:last-child {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						text-align: left;
						width: 50%;

						p:first-child {
							// width: 120px;
							font-size: 30px;
							/*px*/
							// font-weight: bold;
							margin-bottom: 10px;
							line-height: 40px;
							height: 40px;
							overflow: hidden;
							color: rgba(0, 0, 0, 1);
						}

						p:nth-child(2) {
							font-size: 26px;
							/*px*/
							padding-bottom: 10px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.6;
						}

						p:last-child {
							overflow: hidden;
							line-height: 40px;
							height: 80px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.4;
							font-size: 24px;
							/*px*/
						}
					}
				}

				.bookNameList {
					font-size: 30px;
					/*px*/
					overflow: hidden;
					white-space: nowrap;
					margin-right: 10px;
					color: #000;

					p {
						height: 60px;
						line-height: 60px;
						;
					}
				}
			}

			.jinpin_left:nth-child(2n) {
				padding-right: 16px;
				padding-left: 5px;
			}

		}

		// 黑马榜
		.blockHouse {
			background-color: #fff;
			margin: 10px 0;

			.blockHouse_tit {
				display: flex;
				justify-content: space-between;
				padding: 0 12px;
				// line-height: 50px;
				color: #ff4081;
				padding-top: 20px;

				h4 {
					font-size: 32px;
					/*px*/
					padding-bottom: 20px;
				}
			}

			.updata_yp {
				font-size: 26px;
				/*px*/
			}

			ul li:nth-child(4n) {
				margin-right: 0;
			}

			ul {
				padding: 10px 16px;

				li {
					// width: calc((100% - 38px) / 4);
					text-align: center;

					div {
						text-align: center;

						img {
							width: 190px;
							height: 270px;
							text-align: center;
							vertical-align: middle;
							box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
						}
					}


					.bookName {
						width: 175px;
						// overflow: hidden;
						white-space: nowrap;
						margin: 0 auto;
					}

					.bookName {
						color: #000;
						font-size: 30px;
						/*px*/
						padding-top: 20px;
					}

					.jianjie {
						color: #000;
						padding-top: 15px;
						font-size: 24px;
						/*px*/
						height: 40px;
						// overflow: hidden;
						opacity: 0.6;
						margin: 0 0 0 -5px;
						white-space: nowrap;
					}
				}
			}

			// 一键收藏
			.shoucang {
				text-align: center;
				padding: 20px 0 30px;

				button {
					border-radius: 40px;
					padding: 0px 30px;
					height: 50px;
					line-height: 50px;
					border: 1px solid #fec6d5;
					/*no*/
					background-color: #fff8fa;
					color: #ff70a0;
					font-size: 28px;
					/*px*/
				}
			}

			.swiper_ul {
				// padding:10px 56px 10px 20px;
				// box-sizing: border-box;

				.swiper-container {

					.swiper-wrapper {

						.swiper-slide {
							width: 28% !important;
							height: 335px;
							margin-right: 15px !important;
							text-align: center;

							.img_view {
								position: relative;
								width: 100%;

								.input_check {
									width: 40px;
									height: 40px;
									border-radius: 50%;
									position: absolute;
									bottom: 0;
									left: 0;
									background-color: #fff;

									.van-checkbox {}
								}

							}
						}
					}
				}
			}
		}

		// 最近更新
		.updata_box {
			div:first-child {
				display: flex;
				background-color: #fff;
				line-height: 30px;
				padding: 16px;
				color: #fa7298;

				.updata_tit {
					flex: 1;
					display: flex;
					padding: 20px 0;

					p {
						width: calc((100vw - 20px) / 5);
						position: relative;
					}

					p:first-of-type {
						width: 200px;

						.line {
							position: absolute;
							top: 0%;
							right: 15%;
						}
					}

					span {
						font-size: 30px;
						/*px*/
					}

					span.active {
						transform: scale(1.1);
						color: #ff4081;
						font-weight: bold;
					}

					.line {
						color: #dbdbdb;
						position: absolute;
						top: 0%;
						right: 25%;
					}
				}

				.updata_yp {
					font-size: 26px;
					/*px*/
					padding-top: 20px;
				}
			}

			.updata_book {
				color: #585858;
				background-color: #fff;
				padding: 10px 30px 20px;
				overflow: hidden;

				p {
					display: block;
					width: calc(50% - 40px);
					margin-right: 10px;
					padding-right: 10px;
					height: 60px;
					overflow: hidden;
					white-space: nowrap;
					float: left;
					text-align: left;
					font-size: 30px;
					/*px*/
					line-height: 60px;
					color: #000;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}
		}

		//热门标签
		.biaoqianBox {
			margin-top: 10px;
			// margin-bottom: 10px;

			.biaoqianTitle {
				position: relative;
				background-color: #fff;
				padding: 0 16px;

				h4 {
					color: #ff4081;
					padding: 20px 0;
					line-height: 40px;
					font-size: 30px;
					/*px*/
				}

				img {
					position: absolute;
					top: 50%;
					right: 20px;
					transform: translateY(-50%);
					width: 30px;
				}
			}

			.biaoqianList {
				text-align: left;
				overflow: hidden;
				background-color: #fff;
				padding: 0 16px;
				padding-top: 0px;

				button {
					display: inline-block;
					width: calc((100vw - 72px) / 4);
					border-radius: 30px;
					padding: 5px 18px;
					border: 1px solid #fec6d5;
					/*no*/
					background-color: #fff8fa;
					color: #ff70a0;
					// float: left;
					margin-bottom: 20px;
					margin-right: 10px;
					font-size: 26px;
					/*px*/
				}

				button:nth-child(4n) {
					margin-right: 0;
				}
			}
		}

		.lookInfo {
			// margin-top: 10px;
			border-top: 1px solid #f0f0f0;
			/*no*/
			width: 100vw;
			text-align: center;
			padding: 30px 0;
			padding-bottom: 20px;
			background-color: #fff;
			height: 120px;

			span {
				border-radius: 30px;
				padding: 8px 20px;
				color: #b8b8b8;
				font-size: 28px;
				/*px*/
			}
		}

	}
</style>
